import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getAvailableBriefDates = async (queries) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/briefs/talking-points/calendar-statuses?${queries}` });

  return data;
};

export default getAvailableBriefDates;
